/**
 * Pure ref-capture + trigger mechanics behind useGridRefreshRef — factored
 * out so the behavior is verifiable without a React render (this repo has
 * no jsdom/RTL/react-test-renderer test layer; see `sophocles-testing`).
 *
 * Contains:
 * - captureGridRefresh — stash EntityGrid's onGridReady refresh fn into a ref-like container
 * - triggerGridRefresh — call the captured refresh fn; a no-op before capture
 */

/**
 * @param {{ current: Function|null }} refreshRefContainer - a React ref (or ref-shaped object)
 * @param {{ refresh: Function }} api - the payload EntityGrid's onGridReady hands back
 */
export function captureGridRefresh(refreshRefContainer, { refresh }) {
  refreshRefContainer.current = refresh;
}

/**
 * @param {{ current: Function|null }} refreshRefContainer
 */
export function triggerGridRefresh(refreshRefContainer) {
  refreshRefContainer.current?.();
}
